// EventCard.js
import React, { useState, useEffect, useRef } from "react";
import { formatDateWithDay } from "../../utils/dateUtils";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import {
  faEdit,
  faEye,
  faCalendarAlt,
  faCalendar,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";

const EventCard = ({
  title,
  dateOfOccurrence,
  location,
  id,
  onDeleteClick,
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };
  const buttonRef = useRef(null); // Correct reference for the button that toggles the menu
  const isPast = new Date(dateOfOccurrence) < new Date();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuRef]);

  return (
    <div className="card relative w-full overflow-visible rounded-xl bg-white shadow-lg transition hover:-translate-y-0.5 hover:shadow-xl">
      <div className="p-5 flex flex-col min-h-full">
        <div className="flex items-start gap-3">
          <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-lg bg-[#eaf3fa] text-[#004a7e]">
            <FontAwesomeIcon icon={faCalendarAlt} size="lg" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <span
                className={`rounded-md px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide ${
                  isPast
                    ? "bg-gray-100 text-gray-600"
                    : "bg-green-50 text-success"
                }`}
              >
                {isPast ? "Past" : "Upcoming"}
              </span>
            </div>
            <h2 className="mt-2 text-xl font-black leading-tight text-gray-900">
              {title}
            </h2>
            {location && (
              <p className="mt-2 flex items-start gap-2 text-sm text-gray-500">
                <FontAwesomeIcon icon={faLocationDot} className="mt-0.5" />
                <span className="line-clamp-2">{location}</span>
              </p>
            )}
          </div>
          <button
            ref={buttonRef}
            onClick={toggleMenu}
            className="rounded-full p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-800"
          >
            <FontAwesomeIcon icon={faEdit} size="lg" />
          </button>
        </div>
        <div className="mt-4">
          <span className="inline-flex items-center px-3 py-1 rounded-md text-sm font-semibold bg-[#eaf3fa] text-[#004a7e]">
            <FontAwesomeIcon
              icon={faCalendar}
              className="mr-2 h-5 w-5 text-green-600"
            />
            {formatDateWithDay(dateOfOccurrence)}
          </span>
        </div>
        {showMenu && (
          <div
            ref={menuRef}
            className="absolute right-4 top-14 w-48 bg-white rounded-lg shadow-xl z-20 border border-gray-200"
          >
            <ul className="list-none py-1 text-gray-700">
              <li>
                <Link
                  to={`/event/edit/${id}`}
                  className="block px-4 py-2 hover:bg-gray-100"
                >
                  Edit
                </Link>
              </li>
              <li>
                <button
                  onClick={() => onDeleteClick(id)}
                  className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                >
                  Delete
                </button>
              </li>
            </ul>
          </div>
        )}
        <div className="mt-5 flex flex-col gap-2 sm:flex-row">
          <Link
            to={`/event/manage/${id}`}
            className="inline-flex flex-1 items-center justify-center rounded-lg bg-[#004a7e] px-4 py-2.5 text-sm font-bold text-white hover:bg-[#003a64]"
          >
            <FontAwesomeIcon icon={faEye} className="mr-2" /> Manage
          </Link>
          <Link
            to={`/event/edit/${id}`}
            className="inline-flex flex-1 items-center justify-center rounded-lg bg-gray-100 px-4 py-2.5 text-sm font-bold text-gray-700 hover:bg-gray-200"
          >
            Edit
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EventCard;
